import { nameInitials } from '@iconik-io/core/src/name_initials';

export function getInitials(label: string): string {
  const [firstName, lastName] = label.split(' ', 2);
  return nameInitials({ first_name: firstName, last_name: lastName });
}
